import React, {Component} from 'react';
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import StudentinfoComponent from '../components/termreport/termreport.jsx';
import {closeTermreportModal} from "../redux/actions/modelsActive";
import { getBadgeListXueqiRequest,getPingyuRequest} from "../service/user";
import {getHzDzRankingXueqiRequest} from "../service/report";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import {PageFlip} from 'page-flip';
import styles from "../components/termreport/test.module.css";

import HTMLFlipBook from "react-pageflip";

class StudentinfoContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'getBadgeList',
            'openFaceCollectPrompt',
            'onCancel',

        ]);
        this.state = {
            hzsum:'',
            yemian:'',
            jihao:[],
            showFaceCollectPrompt:false,
            pingyu:'',
            showLoading:false,
            loadingResult:'正在生成报告'
        }



    }


    componentDidMount() {

        this.getBadgeList();


            // const pageFlip = new PageFlip(
            //     document.getElementById("demoBookExample"),
            //     {
            //         width: 550, // base page width
            //         height: 733, // base page height
            //
            //         size: "stretch",
            //         // set threshold values:
            //         minWidth: 315,
            //         maxWidth: 1000,
            //         minHeight: 420,
            //         maxHeight: 1350,
            //
            //         maxShadowOpacity: 0.5, // Half shadow intensity
            //         showCover: true,
            //         mobileScrollSupport: false // disable content scrolling on mobile devices
            //     }
            // );
            //
            // // load pages
            // var list = [document.getElementById('page'),document.getElementById('page2'),document.getElementById('page3')]
            // pageFlip.loadFromHTML(list);

            // pageFlip.loadFromHTML(document.querySelectorAll(".page"));

            // document.querySelector(".page-total").innerText = pageFlip.getPageCount();
            // document.querySelector(
            //     ".page-orientation"
            // ).innerText = pageFlip.getOrientation();

            // document.querySelector(".btn-prev").addEventListener("click", () => {
            //     pageFlip.flipPrev(); // Turn to the previous page (with animation)
            // });
            //
            // document.querySelector(".btn-next").addEventListener("click", () => {
            //     pageFlip.flipNext(); // Turn to the next page (with animation)
            // });

            // triggered by page turning
            // pageFlip.on("flip", (e) => {
            //     //document.querySelector(".page-current").innerText = e.data + 1;
            // });

            // triggered when the state of the book changes
            // pageFlip.on("changeState", (e) => {
            //     document.querySelector(".page-state").innerText = e.data;
            // });

            // triggered when page orientation changes
            // pageFlip.on("changeOrientation", (e) => {
            //     document.querySelector(".page-orientation").innerText = e.data;
            // });

        //add
        // document.addEventListener('DOMContentLoaded', function() {
        //
        //     const pageFlip = new PageFlip(
        //         document.getElementById("demoBookExample"),
        //         {
        //             width: 550, // base page width
        //             height: 733, // base page height
        //
        //             size: "stretch",
        //             // set threshold values:
        //             minWidth: 315,
        //             maxWidth: 1000,
        //             minHeight: 420,
        //             maxHeight: 1350,
        //
        //             maxShadowOpacity: 0.5, // Half shadow intensity
        //             showCover: true,
        //             mobileScrollSupport: false // disable content scrolling on mobile devices
        //         }
        //     );
        //
        //     // load pages
        //     pageFlip.loadFromHTML(document.querySelectorAll(".page"));
        //
        //     document.querySelector(".page-total").innerText = pageFlip.getPageCount();
        //     document.querySelector(
        //         ".page-orientation"
        //     ).innerText = pageFlip.getOrientation();
        //
        //     document.querySelector(".btn-prev").addEventListener("click", () => {
        //         pageFlip.flipPrev(); // Turn to the previous page (with animation)
        //     });
        //
        //     document.querySelector(".btn-next").addEventListener("click", () => {
        //         pageFlip.flipNext(); // Turn to the next page (with animation)
        //     });
        //
        //     // triggered by page turning
        //     pageFlip.on("flip", (e) => {
        //         document.querySelector(".page-current").innerText = e.data + 1;
        //     });
        //
        //     // triggered when the state of the book changes
        //     pageFlip.on("changeState", (e) => {
        //         document.querySelector(".page-state").innerText = e.data;
        //     });
        //
        //     // triggered when page orientation changes
        //     pageFlip.on("changeOrientation", (e) => {
        //         document.querySelector(".page-orientation").innerText = e.data;
        //     });
        // });


    }


    openFaceCollectPrompt(){

        this.setState({
            loadingResult:'正在生成报告',
            showLoading:true
        })

        // const doc = new jsPDF();
        // const element = document.getElementById('report');
        //
        // doc.html(element, {
        //     callback: function (pdf) {
        //         pdf.save('exported.pdf');
        //     }
        // });

        this.downloadPDF()
    }

    downloadPDF() {
        const convertToPDF = async () => {
            const doc = new jsPDF();
            // 定义一个函数，用于将单个div转换为PDF并添加到主PDF中
            //html2canvas(div, { scale: 2 }).then
            //scale：该参数用于控制生成的 canvas 的缩放比例。增大这个值可以提高图像的清晰度，
            // 但同时也会增加生成时间和文件大小。例如，将 scale 设置为 2，
            // 可以使生成的图像在宽度和高度上都变为原来的两倍，从而更加清晰。

            const addDivToPDF = async (divId, addNewPage = true) => {
                const div = document.getElementById(divId);
                const canvas = await html2canvas(div, { scale: 2 });
                const imgData = canvas.toDataURL('image/png');
                const imgProps = doc.getImageProperties(imgData);
                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                if (addNewPage) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            };

            // 将第一个div转换为PDF并添加到主PDF中
            await addDivToPDF('header',false);
            // 将第二个div转换为PDF并添加到主PDF中

            await addDivToPDF('xiaoxun');
            await addDivToPDF('xueyuan');
            await addDivToPDF('badge');
            await addDivToPDF('paiming');
            await addDivToPDF('hzdz');
            await addDivToPDF('quxian');
            await addDivToPDF('pingyu');


            doc.save(sessionStorage.getItem('studentname')+'的幸福成长手册.pdf');

            this.setState({
                loadingResult:'报告已生成'
            })
            var that = this;
            setTimeout(function() {
                that.setState({
                    showLoading:false
                })
            }, 2000);

            // 将 canvas 转换为 Blob 对象
            // canvas.toBlob((blob) => {
            //     if (blob) {
            //         const url = URL.createObjectURL(blob);
            //         const a = document.createElement('a');
            //         a.href = url;
            //         a.download = 'output.png';
            //         document.body.appendChild(a);
            //         a.click();
            //         document.body.removeChild(a);
            //         URL.revokeObjectURL(url);
            //     }
            // }, 'image/png');

        };

        try {
            // 可能会出现错误的代码
            convertToPDF();
        } catch (error) {
            this.setState({
                loadingResult:'报告生成失败'
            })
            var that = this;
            setTimeout(function() {
                that.setState({
                    showLoading:false
                })
            }, 2000);
        }



    }

    onCancel(){
        this.setState({
            showFaceCollectPrompt:false
        })
    }

    getBadgeList(){
        getBadgeListXueqiRequest(sessionStorage.getItem('studentpid'), (data) => {
            console.log(data)

            if(data.ret=='1'){
                this.setState({
                    hzsum:data.data.hzsum,
                    yemian:data.data.yemian,
                    jihao:data.data.jihao
                });

            }
        });

        // getHzDzRankingXueqiRequest(sessionStorage.getItem('studentpid'), (data) => {
        //     console.log(data)
        //
        //     if(data.ret=='1'){
        //         this.setState({
        //             badgeMineNum:data.data.student_hz_dz.badge,
        //             badgeAverageNum:data.data.class_avg.bavg,
        //             badgeMaxNum:data.data.class_avg.bmax,
        //             paiming:data.data.student_hz_dz.bpm
        //         });
        //
        //
        //     }
        // });

        getPingyuRequest(sessionStorage.getItem('studentpid'),sessionStorage.getItem('classcode'), (data) => {
            console.log(data)

            if(data.ret=='1'){
                this.setState({
                   pingyu:data.data
                });

            }
        });
    }



    render() {

        return (
            <StudentinfoComponent
                hzsum={this.state.hzsum}
                jihao={this.state.jihao}
                yemian={this.state.yemian}
                showFaceCollectPrompt={this.state.showFaceCollectPrompt}
                closeStudentinfoModal={this.props.closeTermreportModal}
                openFaceCollectPrompt={this.openFaceCollectPrompt}
                onCancel={this.onCancel}
                pingyu={this.state.pingyu}
                showLoading={this.state.showLoading}
                loadingResult={this.state.loadingResult}

            />
        )
    }
}

StudentinfoContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeTermreportModal: () => dispatch(closeTermreportModal()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentinfoContainer);
